import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../../styles/Accordion.module.scss';
import {
  CheckingValidComment,
  clickTracker,
  pathsObj,
  hasJdMartVertical,
  getTextWithNoSpace,
  getCommentErrorMsg,
  andriodSource,
  iosSource,
  getSourceValue,
} from '../../lib/common';
import { CreateTicket, createTicketFeedback, handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

const TagsFeedback = ({
  tagsFeedbackParams,
  setAlert,
  faqQuestion,
  id,
  faqObj,
  activeFaq = '',
  displayAlert,
  leadDetails = {},
}) => {
  const {
    vertical,
    category,
    ticketCreator,
    issue,
    subIssue,
    selectedBusiness,
    userDetails,
    selectedBusinessGenio,
    profile,
    projectId,
  } = tagsFeedbackParams;
  const tagsArr = [
    'Unclear instructions',
    'Incomplete information',
    'Difficult navigation',
    'Irrelevant information',
    'Technical issues',
  ];
  const [tagsData, setTagsData] = useState({
    tagVal: '',
    description: '',
  });
  const navigate = useNavigate();
  const [ticketCreationResp, setTicketCreationResp] = useState('');
  const [feedbackResp, setFeedbackResp] = useState({});
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const location = useLocation();
  const pageType = location.pathname.replace('/csportal', '').replace('/', '') || '';
  const [empData, setEmpData] = useState({});
  const [authState] = useAuth();
  const source = getSourceValue();
  const pageTypeLL =
    pageType === 'payments'
      ? `My Payments and Invoices_${faqQuestion}`
      : `${pathsObj?.[pageType] || ''}_${faqQuestion}`;

  const enableBtn =
    (tagsData?.tagVal && !tagsData?.description) ||
    (tagsData?.description && CheckingValidComment(tagsData?.description));

  const handleTicketCreate = async () => {
    await clickTracker('raiseaticket', pageTypeLL);

    try {
      setIsButtonClicked(true);
      const params = {
        vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : vertical,
        category,
        ticket_creator: ticketCreator,
        nm:
          projectId === 'csportal'
            ? selectedBusiness?.compname || ''
            : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
        created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
        mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
        issue_type: issue,
        issue_sub_type: subIssue,
        issue_comment: tagsData?.description || '',
        document: [],
        city: projectId === 'genio' ? selectedBusinessGenio?.city || '' : selectedBusiness?.data_city,
        oid: '',
        orderid: '',
        docid: projectId === 'genio' ? selectedBusinessGenio?.docId || '' : selectedBusiness?.docid || '',
        src: projectId === 'genio' ? 'sales-genio' : 'business',
        src_typ:
          projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
        src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
        src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
        projectId: projectId === 'csportal' ? 1 : '',
        parentId: projectId === 'genio' ? selectedBusinessGenio?.parentId || '' : selectedBusiness?.parentid || '',
        compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
        source: 'requestcallback_negative_faq',
        bypass_autoclassify: 0,
      };
      if (feedbackResp?.sid) {
        params.feedbackSid = feedbackResp?.sid;
      }
      const res = await CreateTicket(params);
      if (res?.errorCode === 0) {
        setTicketCreationResp(res?.result?.ticket_id || '');
        setEmpData(res?.result?.empdetails || {});
      } else {
        setAlert({
          message: res?.message || '',
          status: false,
        });
      }
      setIsButtonClicked(false);
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = 'click_callbck';
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = `click_${id}`;
        const llTrdInside = `faq_${faqObj?.faqKey}`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
      }
    } catch (err) {
      console.log('Error in ticket creation', err);
    }
    setTagsData({
      tagVal: '',
      description: '',
    });
    setIsButtonClicked(false);
  };
  const handleFeedbackSubmitClick = async () => {
    await clickTracker('savefeedback', pageTypeLL);
    try {
      const params = {
        faq_page_name: pathsObj?.[pageType] || '',
        faq_name: faqQuestion || '',
        cmt: tagsData?.description || '',
        tag: tagsData?.tagVal || '',
        ticket_id: '',
      };
      const resp = await createTicketFeedback(params);
      if (resp?.errorCode === 0) {
        setFeedbackResp(resp?.result || {});
        if (projectId === 'csportal') {
          const liVal = 'click';
          const liTrd = 'click_savefeedback';
          const faqTypeVal = '';
          const othersData = [];
          const llTrd = `click_${faqObj?.faqKey}_nothelpful`;
          await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
        }
      } else {
        setTagsData({
          tagVal: '',
          description: '',
        });
        setAlert({
          message: resp?.result?.msg || 'Something went wrong',
          status: false,
        });
      }
    } catch (err) {
      console.log('Err in handleFeedbackSubmitClick', err);
    }
  };

  const handleTagTracker = async (tag) => {
    const liVal = 'click';
    const liTrd = `click_${getTextWithNoSpace(tag, '_')}`;
    const faqTypeVal = '';
    const othersData = [];
    const llTrd = `click_${faqObj?.faqKey}_nothelpful`;
    await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
  };

  function feedbackRespView() {
    return (
      <div className={`${styles.Accordion__TicketBox} pt-8`}>
        <div className={`${styles.Sucess__Icon} csicon`} />
        <div className="font12 fw600 color111 pl-10">Thank you for helping us improve!</div>
      </div>
    );
  }

  const hasCommentErr =
    tagsData?.description && !CheckingValidComment(tagsData?.description) && tagsData?.description?.length > 3;

  const handleHealthCheck = async () => {
    const url = `https://wap.justdial.com/analytics/competitortrend?docid=${
      selectedBusiness?.docid || ''
    }&m=1&source=${source}&hide_header=1&el=1`;
    if (andriodSource.includes(source) || iosSource.includes(source)) {
      window.open(url);
    } else {
      window.location = url;
    }
  };
  const shouldShowDescription = activeFaq === 'NoLeads' ? descriptionOpen : true;

  function tagsView() {
    return (
      <>
        {displayAlert && activeFaq === 'NoLeads' ? (
          <div className={`${styles.Frame_144858}`}>
            <div className={`${styles.Frame_2125770706}`}>
              <div className={`${styles.Contract_Details}`}>
                You've recieved {leadDetails?.leadscount} leads this week!
              </div>
              <div className={`${styles.Contract_Details_nxt}`}>
                To view all lead details on your dashboard click below
              </div>
              <div
                className={`${styles.Frame_144845}`}
                onClick={() => {
                  handleHealthCheck();
                }}
              >
                <div className={`${styles.btn_text}`}>Go to My Dashboard</div>
              </div>
            </div>
            <div className={`${styles.Frame_2125770706}`}>
              <div className={`${styles.Frame_2125770708}`}>
                <div className={`${styles.notif}`}>Stay Notified</div>
              </div>
              <div className={`${styles.lead_notif}`}>You will get lead notifications on</div>
              <div className={`${styles.Frame_2125770712}`}>
                <span className={`${styles.num}`}>{leadDetails?.mobileFeeback}</span>
                <span
                  className={`${styles.change}`}
                  onClick={() => {
                    window.location.href = leadDetails?.url;
                  }}
                >
                  Change
                </span>
              </div>
              <div className={`${styles.Frame_144847}`} onClick={() => setDescriptionOpen((prev) => !prev)}>
                <span className={`${styles.txt}`}>Still Facing an Issue?</span>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="font12 fw600 color111 mt-16">How can we improve?</div>
            <ul className={`${styles.ChipsList}`}>
              {tagsArr.map((tag, idx) => (
                <li
                  key={idx}
                  className={`${styles.ChipItem} ${tagsData?.tagVal === tag ? styles.Active : ''} font12 fw400`}
                >
                  <div
                    tabIndex={0}
                    role="button"
                    onKeyDown={() => {}}
                    onClick={async () => {
                      setTagsData({ ...tagsData, tagVal: tagsData?.tagVal === tag ? '' : tag });
                      if (tagsData?.tagVal !== tag) {
                        await clickTracker(tag, pageTypeLL);
                        if (projectId === 'csportal') {
                          handleTagTracker(tag);
                        }
                      }
                    }}
                  >
                    {tag}
                  </div>
                </li>
              ))}
            </ul>
          </>
        )}

        {shouldShowDescription && (
          <>
            <div className="mt-10 pl-8">
              <span className="font14">Description:</span>
            </div>
            <textarea
              placeholder="Please write your feedback here"
              value={tagsData.description}
              onChange={(e) => {
                setTagsData({ ...tagsData, description: e.target.value });
              }}
              className={`${styles.Accordion__TextArea} mt-16`}
            />
          </>
        )}
        {hasCommentErr && <span className="colorEC4 font12 fw500">{getCommentErrorMsg(tagsData?.description)}</span>}
        {shouldShowDescription && (
          <button
            type="button"
            onClick={() => handleFeedbackSubmitClick()}
            style={{
              backgroundColor: enableBtn ? '#0076d7' : '#CCCCCC',
              border: `1px solid ${enableBtn ? '#CCCCCC' : '#E0E0E0'}`,
              transitionProperty: 'background-color, background-image, border-color, box-shadow',
              transition: 'all 0.8s',
              color: '#FFFFFF',
            }}
            disabled={!enableBtn}
            className={`${styles.Accordion__Contant__Button} ${
              enableBtn ? 'bluefill_animate' : ''
            } font14 fw600 colorFFF mt-16`}
          >
            Submit
          </button>
        )}
      </>
    );
  }

  function ticketCreateBtnView() {
    return (
      <>
        <br />
        <br />
        <div className={`${styles.Assistance}`}>
          <div className="font12 fw700 color111">Need further assistance?</div>
          <button
            disabled={isButtonClicked || hasCommentErr}
            type="button"
            onClick={() => handleTicketCreate()}
            className={`${styles.AssistanceButton} ${
              !hasCommentErr ? 'blue_whitefill_animate' : ''
            } font12 fw600 color007 mt-16`}
            style={{
              backgroundColor: hasCommentErr ? '#CCCCCC' : '',
              border: `1px solid ${hasCommentErr ? '#CCCCCC' : '#2599f8'}`,
              transitionProperty: 'background-color, background-image, border-color, box-shadow',
              transition: 'all 0.8s',
              color: hasCommentErr ? '#FFFFFF' : '',
            }}
          >
            Request a Callback
          </button>
        </div>
      </>
    );
  }

  function ticketCreationRespView() {
    const agentName = empData?.empnm || empData?.empname || '';
    const showAgentName = !agentName?.includes('AI Bot');
    return (
      <div className="p-8">
        <div className="font13 fw600 color111">Your complaint is registered with us!</div>
        <div className="font12 fw400 color111 mt-10">
          Reference Id : <span className="fw600">{ticketCreationResp}</span>
        </div>
        <div className="font12 fw400 color111 mt-6">
          Our support executive {showAgentName && <span className="fw600">{agentName}</span>} will get back to you in{' '}
          <span className="fw600">24-72 hours!</span>
        </div>
        <button
          type="button"
          onClick={() => {
            navigate('/csportal/myTickets');
          }}
          className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-16`}
        >
          View My Ticket
        </button>
      </div>
    );
  }

  return (
    <div className="pl-8 pr-8">
      {feedbackResp?.msg && !ticketCreationResp && feedbackRespView()}
      {!feedbackResp?.msg && !ticketCreationResp && tagsView()}
      {ticketCreationResp && ticketCreationRespView()}
      {!ticketCreationResp && ticketCreateBtnView()}
    </div>
  );
};

export default TagsFeedback;

TagsFeedback.propTypes = {
  tagsFeedbackParams: PropTypes.object,
  setAlert: PropTypes.func,
  faqQuestion: PropTypes.string,
  id: PropTypes.string,
  faqObj: PropTypes.object,
  displayAlert: PropTypes.bool,
  activeFaq: PropTypes.string,
  leadDetails: PropTypes.object,
};
